import React, {Component} from 'react';

const ANIMALS_CONTROL = "animals"
const ANIMALS_CONTROL_DETAIL = "animalDetail"

class ListFeatures extends Component {


    constructor(props) {
        super(props);
        //console.log("ListFeatures::constructor()");
    }


    renderFeatures() {


        return this.props.features.map((feature,index) => {
            return (
                <div key={"feature-"+index} className="re-DetailFeaturesList-feature">
                    <div className="re-DetailFeaturesList-featureIcon">
                        <span className={feature.classIcon}/>
                    </div>
                    <div className="re-DetailFeaturesList-featureContent"><p
                        className="re-DetailFeaturesList-featureLabel">{feature.label}</p><p
                        className="re-DetailFeaturesList-featureValue">{feature.value}</p></div>
                </div>
            )
        })
    }

    render() {
        //console.log("ListFeatures::render()");

        return (
            <section className="sui-SectionInfo">
                <div className="sui-SectionInfo-content sui-SectionInfo-content--withoutTitle">
                    {/*<h2 className="re-RealestateDetail--sectionTitle">{this.props.title}</h2>*/}
                    <h3 className="card-title ">{this.props.title}</h3>
                    <div className="re-RealestateDetail-featuresListWrapper">
                        <div className="re-DetailFeaturesList">


                            {this.renderFeatures()}
                            {/*<div className="re-DetailFeaturesList-feature">*/}
                            {/*    <div className="re-DetailFeaturesList-featureIcon">*/}
                            {/*        <span className="las la-3x la-birthday-cake"/>*/}
                            {/*    </div>*/}
                            {/*    <div className="re-DetailFeaturesList-featureContent"><p*/}
                            {/*        className="re-DetailFeaturesList-featureLabel">Tipo de inmueble</p><p*/}
                            {/*        className="re-DetailFeaturesList-featureValue">Piso</p></div>*/}
                            {/*</div>*/}
                            {/*<div className="re-DetailFeaturesList-feature">*/}
                            {/*    <div className="re-DetailFeaturesList-featureIcon"><span*/}
                            {/*        className="las la-3x la-birthday-cake"/>*/}

                            {/*    </div>*/}
                            {/*    <div className="re-DetailFeaturesList-featureContent"><p*/}
                            {/*        className="re-DetailFeaturesList-featureLabel">Orientación</p><p*/}
                            {/*        className="re-DetailFeaturesList-featureValue">Sureste</p></div>*/}
                            {/*</div>*/}
                            {/*<div className="re-DetailFeaturesList-feature">*/}
                            {/*    <div className="re-DetailFeaturesList-featureIcon">*/}
                            {/*        <span className="las la-3x la-birthday-cake"/>*/}
                            {/*    </div>*/}
                            {/*    <div className="re-DetailFeaturesList-featureContent"><p*/}
                            {/*        className="re-DetailFeaturesList-featureLabel">Agua caliente</p><p*/}
                            {/*        className="re-DetailFeaturesList-featureValue">Gas Natural</p></div>*/}
                            {/*</div>*/}
                            {/*<div className="re-DetailFeaturesList-feature">*/}
                            {/*    <div className="re-DetailFeaturesList-featureIcon"><span*/}
                            {/*        className="las la-3x la-birthday-cake"/>*/}
                            {/*    </div>*/}
                            {/*    <div className="re-DetailFeaturesList-featureContent"><p*/}
                            {/*        className="re-DetailFeaturesList-featureLabel">Calefacción</p><p*/}
                            {/*        className="re-DetailFeaturesList-featureValue">Gas Natural</p></div>*/}
                            {/*</div>*/}
                            {/*<div className="re-DetailFeaturesList-feature">*/}
                            {/*    <div className="re-DetailFeaturesList-featureIcon"><span*/}
                            {/*        className="las la-3x la-birthday-cake"/>*/}
                            {/*    </div>*/}
                            {/*    <div className="re-DetailFeaturesList-featureContent"><p*/}
                            {/*        className="re-DetailFeaturesList-featureLabel">Estado</p><p*/}
                            {/*        className="re-DetailFeaturesList-featureValue">Bien</p></div>*/}
                            {/*</div>*/}
                            {/*<div className="re-DetailFeaturesList-feature">*/}
                            {/*    <div className="re-DetailFeaturesList-featureIcon"><span*/}
                            {/*        className="las la-3x la-birthday-cake"/>*/}
                            {/*    </div>*/}
                            {/*    <div className="re-DetailFeaturesList-featureContent"><p*/}
                            {/*        className="re-DetailFeaturesList-featureLabel">Antigüedad</p><p*/}
                            {/*        className="re-DetailFeaturesList-featureValue">+ 100 años</p></div>*/}
                            {/*</div>*/}
                            {/*<div className="re-DetailFeaturesList-feature">*/}
                            {/*    <div className="re-DetailFeaturesList-featureIcon"><span*/}
                            {/*        className="las la-3x la-birthday-cake"/>*/}
                            {/*    </div>*/}
                            {/*    <div className="re-DetailFeaturesList-featureContent"><p*/}
                            {/*        className="re-DetailFeaturesList-featureLabel">Planta</p><p*/}
                            {/*        className="re-DetailFeaturesList-featureValue">3ª planta</p></div>*/}
                            {/*</div>*/}
                            {/*<div className="re-DetailFeaturesList-feature">*/}
                            {/*    <div className="re-DetailFeaturesList-featureIcon"><span*/}
                            {/*        className="las la-3x la-birthday-cake"/>*/}
                            {/*    </div>*/}
                            {/*    <div className="re-DetailFeaturesList-featureContent"><p*/}
                            {/*        className="re-DetailFeaturesList-featureLabel">Parking</p><p*/}
                            {/*        className="re-DetailFeaturesList-featureValue">Privado</p></div>*/}
                            {/*</div>*/}
                            {/*<div className="re-DetailFeaturesList-feature">*/}
                            {/*    <div className="re-DetailFeaturesList-featureIcon"><span*/}
                            {/*        className="las la-3x la-birthday-cake"/>*/}
                            {/*    </div>*/}
                            {/*    <div className="re-DetailFeaturesList-featureContent"><p*/}
                            {/*        className="re-DetailFeaturesList-featureLabel">Consumo energía</p>*/}
                            {/*        <p className="re-DetailFeaturesList-featureValue">*/}
                            {/*            <div className="re-DetailEnergyCertificate-itemList">*/}
                            {/*                <div className="re-DetailEnergyCertificate-itemComposed">*/}
                            {/*                    <div*/}
                            {/*                        className="re-DetailEnergyCertificate-item re-DetailEnergyCertificate-value--e">E*/}
                            {/*                    </div>*/}
                            {/*                    <div className="re-DetailEnergyCertificate-itemUnits">190 kW*/}
                            {/*                        h*/}
                            {/*                        m² / año*/}
                            {/*                    </div>*/}
                            {/*                </div>*/}
                            {/*            </div>*/}
                            {/*        </p>*/}
                            {/*    </div>*/}
                            {/*</div>*/}
                            {/*    <div className="re-DetailFeaturesList-feature">*/}
                            {/*        <div className="re-DetailFeaturesList-featureIcon">                                            <span className="las la-3x la-birthday-cake"/>*/}
                            {/*        </div>*/}
                            {/*        <div className="re-DetailFeaturesList-featureContent"><p*/}
                            {/*            className="re-DetailFeaturesList-featureLabel">Emisiones</p>*/}
                            {/*            <p className="re-DetailFeaturesList-featureValue">*/}
                            {/*                <div className="re-DetailEnergyCertificate-itemList">*/}
                            {/*                    <div className="re-DetailEnergyCertificate-itemComposed">*/}
                            {/*                        <div*/}
                            {/*                            className="re-DetailEnergyCertificate-item re-DetailEnergyCertificate-value--e">E*/}
                            {/*                        </div>*/}
                            {/*                        <div className="re-DetailEnergyCertificate-itemUnits">40 kg CO₂*/}
                            {/*                            m² / año*/}
                            {/*                        </div>*/}
                            {/*                    </div>*/}
                            {/*                </div>*/}
                            {/*            </p>*/}
                            {/*        </div>*/}
                            {/*    </div>*/}
                        </div>
                        {/*<div className="re-DetailEnergyCertificate--displaced"><p*/}
                        {/*    className="re-DetailEnergyCertificate-link">Ver etiqueta calificación energética</p>*/}
                        {/*</div>*/}
                        {/*<div className="re-DetailExtras">*/}
                        {/*    <ul className="re-DetailExtras-list">*/}
                        {/*        <li className="re-DetailExtras-listItem">Trastero</li>*/}
                        {/*        <li className="re-DetailExtras-listItem">Balcón</li>*/}
                        {/*    </ul>*/}
                        {/*</div>*/}
                    </div>
                </div>
            </section>
        );
    }

    componentWillMount() {
        //console.log(" ListFeatures::componentWillMount()");
    }

    componentDidMount() {
        //console.log(" ListFeatures::componentDidMount()");
    }

    componentWillUpdate(nextProps, nextState, nextContext) {
        //console.log(" ListFeatures::componentWillUpdate()");

    }

    componentDidUpdate() {
        //console.log(" ListFeatures::componentDidUpdate()");
    }


}

//El primer parametro es el mapeo de las props y el segundo las acciones- luego se le coloca que componente se ejecuta
export default ListFeatures
